import ReadMoreComponent from './ReadMoreComponent'
import './css/specialinstructions.css';
import { formatHTML } from '../data/utils';

type SpecialInstructionsProperties = {
    workorder?: any;
    expanded?: boolean;
}

export default function SpecialInstructionComponent(props: SpecialInstructionsProperties) {
    if (!props.workorder || !props.workorder.has_description) return (<></>);
    const parentDescriptions = props.workorder.parent_special_instructions.map((s: any) => {
        return (<div key={`spec_${s.id}`}>
            {s.special_instructions ? <>
            <div className="hierarchy_instruction_label">{s.name + ' ' + (s.asset_type === 'E' ? '(Equipment)':'(Site)')}</div>
            <div dangerouslySetInnerHTML={{ __html: formatHTML(s.special_instructions) }} className="hierarchy_instruction"/>
        </> : <></>}
        </div>)
    });
    parentDescriptions.reverse();
    const specialInstructions = (<>
        {props.workorder.tech_notes ? <>
            <div key="spec_tech_notes">
                <div className="hierarchy_instruction_label">{props.workorder.name}</div>
                <div dangerouslySetInnerHTML={{ __html: formatHTML(props.workorder.tech_notes) }} className="hierarchy_instruction"/>
            </div>
        </> : <></>}
        {parentDescriptions}
    </>)
    return (
        <div className="wo_special_instructions">
            <ReadMoreComponent expanded={props.expanded || false}>{specialInstructions}</ReadMoreComponent>
        </div>
    )
}